<template>
  <div class="snackbar-center" :style="{ bottom: bottom }">
    <div
      class="shadow-lg rounded snack-content d-grid p-4 align-items-center"
      :class="[
        {
          small: layout === 'small',
          multiline: layout === 'multiline'
        },
        style_class
      ]"
    >
      <div>
        <slot></slot>
      </div>
      <slot name="action"> </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core'

const { style_class = 'bg-dark border', layout = 'small' } = defineProps<{
  layout?: 'small' | 'multiline'
  style_class?: string
}>()

const bottom = Capacitor.isNativePlatform() ? '100px' : '30px'
</script>

<style lang="scss">
.snackbar-center {
  width: 100vw;
  display: flex;
  justify-content: space-around;
  position: fixed; /* Sit on top of the screen */
  z-index: 10;
  left: 0;
}

.snack-content {
  width: 95%;
  max-width: 600px;

  &.small {
    grid-template-columns: auto min-content;
    column-gap: 20px;
  }

  &.multiline {
    grid-template-rows: auto min-content;
    row-gap: 20px;
  }
}
</style>
